import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  ids: string[]
}

type Response = { items: IUserTicketData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { ids } = props

  const endpoint = ApiEndpoint.v4.ticket.bulk(ids)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
